export default {
	title: "ラッキーホイール",
	Lucky: "ラッキー",
	wheels: "ホイール",
	winningrecord: "当選記録",
	ActivityRules: "アクティビティルール",
	ActivityRulesContent: "抽選についての詳細は、カスタマーサービスにお問い合わせください。",
	award: {
		title: "おめでとうございます！",
		btn: "賞品を受け取る"
	},
	noticeItem: "{0}が{1}を獲得しました",
	lotteryDraws: "{0}回の抽選",
	noAvailableTimes: "利用可能な試行回数が不足しています。カスタマーサービスにお問い合わせください。",
	noOpen: "まだ開いていません",
	noWinning: "引き続き頑張ってください",
	ViewALlPrizes: "すべての賞品を見る",
	myPrizes: "私の賞品",
	share: "友達と共有"
};
